import styled from 'styled-components';
import WebFontLoader from 'webfontloader';
import { BoxFlexProps } from './type';

WebFontLoader.load({
  google: {
    families: ['Poppins:300,400,500,600&display=swap'],
  },
});

const StyledBoxFlex = styled.div<BoxFlexProps>`
  display: ${({ display }) => display || 'flex'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  align-content: ${({ alignContent }) => alignContent || 'stretch'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
  flex-grow: ${({ flexGrow }) => flexGrow || 0};
  flex-shrink: ${({ flexShrink }) => flexShrink || 1};
  flex-basis: ${({ flexBasis }) => flexBasis || 'auto'};
  order: ${({ order }) => order || 0};
  align-self: ${({ alignSelf }) => alignSelf || 'auto'};
  font-family: 'Poppins', sans-serif;
  font-weight: ${({ weight }) => {
    switch (weight) {
      case 'light':
        return 300;
      case 'normal':
        return 400;
      case 'semibold':
        return 500;
      case 'bold':
        return 600;
      default:
        return 400;
    }
  }};
  gap: ${({ gap }) => gap || '0'};
`;

export default StyledBoxFlex;
